import * as Backbone from "backbone";
import * as $ from "jquery";
import * as _ from "lodash";
import { PermissionCollection } from "../../../collections/Permissions";
import { UserGroupCollection } from "../../../collections/UserGroups";
import { GenericDeleteModal } from "../GenericDeleteModal";
import { BaseModifyModalView, BaseModifyModalViewOptions } from "../_BaseModifyModal";


var template = require('templates/modals/dashboard/modifyDashboard.html');
require('bootstrap-toggle');


interface ModifyDashboardModalOptions extends BaseModifyModalViewOptions {
    dashboardId?: number;
    name?: string;
    clone?: boolean;
    generate?: boolean;
    installId?: number;
}

export class ModifyDashboardModal extends BaseModifyModalView {

    options: ModifyDashboardModalOptions;
    userGroupCollection: UserGroupCollection = null;
    userGroupPermissionsCollections: { [key: number]: PermissionCollection } = {};
    dashboardType: string = 'datatype'; // Default to organizing dashboards by data type

    template = _.template(template);

    constructor(options: ModifyDashboardModalOptions) {
        super(<any>_.extend({
            tagName: "div",
            events: {
                'shown.bs.modal #addDashboardModal': 'handleModalShown',
                'hidden.bs.modal #addDashboardModal': 'handleModalHidden',
                'change .add-dashboard-modal-org-select': 'handleOrgChange',
                'change .permission-checkbox': 'handlePermissionChange',
                'click .dashboard-submit': 'handleSubmitButtonClick',
                'click .delete-dashboard-btn': 'handleDeleteDashboardButtonClick',
                'input .add-dashboard-modal-dashboard-name': 'handleInputDashboardName'
            }
        }, options));

        // For the base class methods
        this.modalIdSelector = 'addDashboardModal';

        this.handleInputDashboardName = _.debounce(this.handleInputDashboardName, 100);
    }

    render() {
        var name = this.options.name || '';
        var orgId = null;
        if (this.options.dashboardId) {
            var db = this.options.dashboardCollection.findWhere({ id: this.options.dashboardId });
            name = db.get('name');
            orgId = db.get('organization_id');
        }

        this.$el.html(this.template({
            organizationCollection: this.options.organizationCollection,
            newDashboard: !this.options.dashboardId,
            dashboardId: this.options.dashboardId,
            permissionCollection: this.options.permissionCollection,
            name: name,
            organizationId: orgId,
            clone: this.options.clone,
            generate: this.options.generate
        }));

        this.delegateEvents();
        return this;
    }

    show() {
        super.show();
        this.handleOrgChange();
    }

    handleOrgChange() {
        var orgId = this.$('.add-dashboard-modal-org-select').val();

        // Use optimized dashboard permission loading if we have a dashboard ID
        if (this.options.modelId) {
            $.when(this.loadDashboardPermissions(Number(this.options.modelId), Number(orgId)))
                .then(() => {
                    this.handleAddButtonDisabledState();
                });
        } else {
            // For new dashboards, use the original method
            $.when(this.loadPermissionsCollections(
                orgId,
                'canViewDashboard',
                'canModifyDashboard',
                'canDeleteDashboard'
            )).then(() => {
                this.handleAddButtonDisabledState();
            });
        }
    }

    handleInputDashboardName() {
        this.handleAddButtonDisabledState();
    }

    
    handleAddButtonDisabledState() {
        var canAssignPerms = false;

        if (this.userGroupCollection) {
            if (this.userGroupCollection.isFetching()) {
                this.$('.add-dashboard-btn').prop('disabled', true);
                this.$('.modify-dashboard-btn').prop('disabled', true);
                this.$('.clone-dashboard-btn').prop('disabled', true);
                this.$('.generate-dashboard-btn').prop('disabled', true);
                return;
            }

            // Only allow a new dashboard to be created if the user can assign permissions
            this.userGroupCollection.each((group) => {
                if (this.options.permissionCollection.canModifyUserGroupPermissions(group.get('id'))) canAssignPerms = true;
            })
        }

        // Make sure the dashboard is named
        if (!this.$('.add-dashboard-modal-dashboard-name').val() || !canAssignPerms) {
            this.$('.add-dashboard-btn').prop('disabled', true);
            this.$('.modify-dashboard-btn').prop('disabled', true);
            this.$('.clone-dashboard-btn').prop('disabled', true);
            this.$('.generate-dashboard-btn').prop('disabled', true);
            return;
        }

        // Make sure at least one dashboard has all permissions
        var allPerms = _.some(this.$('.permission-modify').map(function () {
            return $(this).is(':checked')
        }));
        this.$('.add-dashboard-btn').prop('disabled', !allPerms);
        this.$('.modify-dashboard-btn').prop('disabled', !allPerms);
        this.$('.clone-dashboard-btn').prop('disabled', !allPerms);
        this.$('.generate-dashboard-btn').prop('disabled', !allPerms);
    }

    handleDeleteDashboardButtonClick() {
        var db = this.options.dashboardCollection.findWhere({ id: this.options.dashboardId });
        var modal = new GenericDeleteModal({
            type: 'Dashboard',
            name: db.get('name'),
            func: () => {
                this.setFormSubmitted();
                window['App'].Bus.trigger('dashboard:update:suspend');

                return $.ajax({
                    type: "DELETE",
                    url: this.options.dashboardCollection.url() + '/' + this.options.dashboardId,
                    dataType: 'json',
                    contentType: "application/json; charset=utf-8",
                    success: () => {
                        this.refetchCollectionsAndShowDashboard()
                    },
                    error: function () {
                        (<any>$).notify({
                            title: 'Something went wrong',
                            message: 'Please reload the page and try again',
                            icon: 'fa fa-exclamation-circle',
                        }, {
                            animate: {
                                enter: 'animated fadeInUp',
                            },
                            // The type property defines the css style
                            // See alerts.less for available styles
                            type: "warning-alt",
                            placement: { from: "bottom", align: "center" }
                        });
                    }
                });
            }
        });
        $('.modals').append(modal.render().el);
        modal.show();
    }

    handleSubmitButtonClick(e: JQuery.UIEventBase) {
        this.setFormSubmitted();
        window['App'].Bus.trigger('dashboard:update:suspend');

        var buttonClasses: string[] = _.map($(e.currentTarget).prop('classList'));
        var action = 'POST';
        var urlAddOn = '';
        var data = {
            organizationId: Number(this.$('.add-dashboard-modal-org-select').val()),
            name: this.$('.add-dashboard-modal-dashboard-name').val(),
            permissions: this.getPermissionsDict()
        };

        // Default options prevail, unless we're cloning or auto-generating a dashboard
        if (_.includes(buttonClasses, 'clone-dashboard-btn')) {
            data = _.extend({
                dashboardId: this.options.dashboardId
            }, data);
            urlAddOn = '/clone';
        } else if (_.includes(buttonClasses, 'generate-dashboard-btn')) {
            data = _.extend({
                dashboardType: this.$('input[name=dashboardType]:checked').val(),
                installId: this.options.installId
            }, data);
            urlAddOn = '/generate';
        } else if (_.includes(buttonClasses, 'modify-dashboard-btn')) {
            action = 'PUT';
            urlAddOn = '/' + this.options.dashboardId;
        }

        $.ajax({
            type: action,
            url: this.options.dashboardCollection.url() + urlAddOn,
            data: JSON.stringify(data),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            success: (response) => {
                const dashboardId = action === 'PUT' ? this.options.dashboardId : response.dashboardId;
                this.refetchCollectionsAndShowDashboard(dashboardId)
            },
            error: function () {
                (<any>$).notify({
                    title: 'Something went wrong',
                    message: 'Please reload the page and try again',
                    icon: 'fa fa-exclamation-circle',
                }, {
                    animate: {
                        enter: 'animated fadeInUp',
                    },
                    // The type property defines the css style
                    // See alerts.less for available styles
                    type: "warning-alt",
                    placement: { from: "bottom", align: "center" }
                });
            }
        });
    }

    refetchCollectionsAndShowDashboard(dashboardId?) {
        var d1 = this.options.dashboardCollection.fetch({ reset: true });
        var d2 = this.options.permissionCollection.fetch({ reset: true });
        // We do not need to refetch the dashboard channel collection because we are reloading the page and refetching on reload
        // var d3 = this.options.dashboardChannelCollection.fetch({reset: true});

        $.when(d1, d2).done(() => {
            this.hide();
            if (!dashboardId || dashboardId !== this.options.dashboardId) {
                window.location.hash = "#/dashboard" + (dashboardId ? '/' + dashboardId : '');
            } else {
                // Somewhat of a hack to refresh the page
                // See http://stackoverflow.com/questions/8901574/how-to-refresh-a-page-in-a-backbone-application
                Backbone.history.loadUrl();
            }

            window['App'].Bus.trigger('navigation:update');
        }).fail(() => {
            this.setFormError();
            (<any>$).notify({
                title: 'Something went wrong',
                message: 'Please reload the page and try again',
                icon: 'fa fa-exclamation-circle',
            }, {
                animate: {
                    enter: 'animated fadeInUp',
                },
                // The type property defines the css style
                // See alerts.less for available styles
                type: "warning-alt",
                placement: { from: "bottom", align: "center" }
            });
        })
    }

}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/dashboard/ModifyDashboardModal.ts